import { devLog } from "./devLog";

/**
 * Lightweight analytics hook-up: forwards to gtag when present.
 * @param {string} name
 * @param {Record<string, string | number | boolean | undefined>} [params]
 */
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", name, params);
    }
  } catch {
    /* ignore */
  }
  devLog("[analytics]", name, params);
}
